(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button’s row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mlo-page-a-remplir"] && !Shopify.designMode) return;
  try {
    
/*
  La page à remplir — réécriture en direct.

  Le script ne crée aucun contenu : la question est déjà imprimée par le
  serveur avec les valeurs d’exemple. Il se contente de remplacer les mots
  quand on tape, et de faire tourner les questions modèles.

  Trois détails valent la peine d’être signalés :

  — tant que la question ne change pas de forme, on ne réécrit que le texte
    du mot, sans reconstruire le trait de stylo : il ne se redessine donc
    pas à chaque touche du clavier ;
  — la question n’est pas une zone « live ». Elle serait relue à chaque
    frappe. Un paragraphe caché la relit une seule fois : la frappe finie,
    ou le fondu passé quand le visiteur a lui-même changé de question ;
  — cliquer une puce arrête le défilement automatique pour de bon. On ne se
    fait pas voler la question qu’on vient de choisir, et un contenu qui se
    met à jour tout seul doit pouvoir être arrêté.
*/

(() => {
  const moinsDeMouvement = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Dessine un trait de stylo fraîchement posé dans la page. */
  function tracer(svg) {
    const trait = svg.querySelector('path');
    if (!trait) return;

    if (moinsDeMouvement.matches) {
      svg.dataset.mloTraceFait = 'true';
      return;
    }

    let longueur = 0;
    try {
      longueur = trait.getTotalLength();
    } catch {
      return;
    }
    if (!longueur) return;

    trait.style.transition = 'none';
    trait.style.strokeDasharray = String(longueur);
    trait.style.strokeDashoffset = String(longueur);
    svg.dataset.mloTracePret = 'true';

    // On force la prise en compte de l’état de départ avant d’animer.
    void trait.getBoundingClientRect();

    trait.style.transition = 'stroke-dashoffset 620ms cubic-bezier(.2,.7,.3,1)';
    trait.style.strokeDashoffset = '0';
    svg.dataset.mloTraceFait = 'true';
  }

  /* Le premier nœud de texte d’un mot souligné, créé au besoin. */
  function noeudTexte(element) {
    let premier = element.firstChild;
    if (!premier || premier.nodeType !== 3) {
      premier = document.createTextNode('');
      element.insertBefore(premier, element.firstChild);
    }
    return premier;
  }

  function initialiser(racine) {
    if (racine.dataset.mloRemplirPret === 'true') return;

    const phrase = racine.querySelector('[data-mlo-phrase]');
    const zone = racine.querySelector('[data-mlo-question]');
    const gabarits = {
      prenom: racine.querySelector('[data-mlo-gabarit="prenom"]'),
      ville: racine.querySelector('[data-mlo-gabarit="ville"]')
    };
    if (!phrase || !zone || !gabarits.prenom || !gabarits.ville) return;

    const puces = Array.from(racine.querySelectorAll('[data-mlo-puce]'));
    const modeles = puces
      .map((puce) => puce.dataset.mloModele || '')
      .filter((modele) => modele.length > 0);
    if (modeles.length === 0) return;

    racine.dataset.mloRemplirPret = 'true';

    const saisies = {
      prenom: racine.querySelector('[data-mlo-saisie="prenom"]'),
      ville: racine.querySelector('[data-mlo-saisie="ville"]')
    };
    const annonce = racine.querySelector('[data-mlo-annonce]');
    const exemples = {
      prenom: racine.dataset.mloPrenomExemple || '',
      ville: racine.dataset.mloVilleExemple || ''
    };
    const duree = parseInt(racine.dataset.mloDuree, 10) || 6000;

    let index = 0;
    // Le texte déjà imprimé par le serveur, pour ne rien reconstruire à tort.
    let texteCourant = zone.dataset.mloTexteInitial || null;
    /*
      Tant que le visiteur n’a rien écrit, la feuille reste la page d’exemple
      imprimée par le serveur — prénom ET ville renseignés. Sans ce garde-fou,
      le script remplacerait la question par son repli sans ville dès le
      chargement, et l’exemple sauterait sous les yeux du visiteur. S’il
      efface tout, l’exemple revient : il vaut mieux qu’une phrase amputée.
    */
    let vierge = true;
    let jetons = {
      prenom: Array.from(zone.querySelectorAll('[data-mlo-jeton="prenom"]')),
      ville: Array.from(zone.querySelectorAll('[data-mlo-jeton="ville"]'))
    };

    /* ---------------------------------------------------------------- */
    /* Choix de la question et des mots                                  */
    /* ---------------------------------------------------------------- */

    function saisi() {
      return {
        prenom: saisies.prenom ? saisies.prenom.value.trim() : '',
        ville: saisies.ville ? saisies.ville.value.trim() : ''
      };
    }

    /*
      Une ligne peut porter deux versions séparées par « | » : celle qui cite
      la ville, puis le repli qui s’en passe. Le repli n’entre en jeu qu’une
      fois le visiteur au clavier : avant, la page montre l’exemple complet.
      Sans repli, on retombe sur la ville d’exemple plutôt que sur un trou.
    */
    function resoudre(modele, valeurs) {
      const morceaux = modele.split('|');
      const avec = morceaux[0].trim();
      const sans = morceaux.length > 1 ? morceaux.slice(1).join('|').trim() : '';

      let texte = avec;
      let ville = valeurs.ville;

      if (!ville) {
        if (sans && !vierge) {
          texte = sans;
          ville = '';
        } else {
          ville = exemples.ville;
        }
      }

      return {
        texte,
        mots: { prenom: valeurs.prenom || exemples.prenom, ville }
      };
    }

    /* ---------------------------------------------------------------- */
    /* Écriture sur la feuille                                           */
    /* ---------------------------------------------------------------- */

    function motSouligne(nom, valeur) {
      const modele = gabarits[nom].content.firstElementChild;
      const copie = modele.cloneNode(true);
      noeudTexte(copie).nodeValue = valeur;
      return copie;
    }

    function peindre(texte, mots) {
      // Même question : seuls les mots changent, le trait reste en place.
      if (texte === texteCourant) {
        jetons.prenom.forEach((el) => {
          noeudTexte(el).nodeValue = mots.prenom;
        });
        jetons.ville.forEach((el) => {
          noeudTexte(el).nodeValue = mots.ville;
        });
        return;
      }

      texteCourant = texte;

      const fragment = document.createDocumentFragment();
      const neufs = { prenom: [], ville: [] };
      const motif = /\{(prenom|ville)\}/g;
      let curseur = 0;
      let trouve;

      while ((trouve = motif.exec(texte)) !== null) {
        if (trouve.index > curseur) {
          fragment.appendChild(
            document.createTextNode(texte.slice(curseur, trouve.index))
          );
        }
        const mot = motSouligne(trouve[1], mots[trouve[1]]);
        neufs[trouve[1]].push(mot);
        fragment.appendChild(mot);
        curseur = trouve.index + trouve[0].length;
      }
      if (curseur < texte.length) {
        fragment.appendChild(document.createTextNode(texte.slice(curseur)));
      }

      zone.textContent = '';
      zone.appendChild(fragment);
      jetons = neufs;

      // Les traits qui viennent d’arriver se dessinent.
      zone.querySelectorAll('.mlo-trace').forEach(tracer);
    }

    function rafraichir() {
      const resultat = resoudre(modeles[index], saisi());
      peindre(resultat.texte, resultat.mots);
    }

    /* ---------------------------------------------------------------- */
    /* Les questions se succèdent                                        */
    /* ---------------------------------------------------------------- */

    let minuteur = null;
    let minuteurFondu = null;
    let minuteurAnnonce = null;
    let visible = true;
    let enSaisie = false;
    /*
      Dès que le visiteur choisit une question lui-même, le défilement
      automatique s’arrête et ne repart plus : c’est lui qui mène.
    */
    let pilote = false;

    function majPuces() {
      puces.forEach((puce, rang) => {
        puce.setAttribute('aria-current', rang === index ? 'true' : 'false');
      });
    }

    function arreter() {
      if (minuteur === null) return;
      window.clearInterval(minuteur);
      minuteur = null;
    }

    function relancer() {
      arreter();
      const possible =
        modeles.length > 1 &&
        !pilote &&
        !moinsDeMouvement.matches &&
        visible &&
        !enSaisie;
      if (!possible) return;
      minuteur = window.setInterval(() => {
        // L’éditeur de thème remplace la section : on ne fait pas tourner
        // une horloge au-dessus d’un morceau de page qui n’existe plus.
        if (racine.isConnected === false) {
          arreter();
          return;
        }
        aller(index + 1);
      }, duree);
    }

    function aller(rang) {
      const total = modeles.length;
      index = ((rang % total) + total) % total;
      majPuces();

      if (moinsDeMouvement.matches) {
        rafraichir();
        return;
      }

      window.clearTimeout(minuteurFondu);
      phrase.dataset.mloFondu = 'true';
      minuteurFondu = window.setTimeout(() => {
        rafraichir();
        phrase.dataset.mloFondu = 'false';
      }, 240);
    }

    /* Relecture différée : une seule fois, la frappe ou le fondu terminés. */
    function annoncer(delai) {
      if (!annonce) return;
      window.clearTimeout(minuteurAnnonce);
      minuteurAnnonce = window.setTimeout(() => {
        annonce.textContent = zone.textContent;
      }, delai || 900);
    }

    /* ---------------------------------------------------------------- */
    /* Branchements                                                      */
    /* ---------------------------------------------------------------- */

    Object.keys(saisies).forEach((nom) => {
      const champ = saisies[nom];
      if (!champ) return;
      champ.addEventListener('input', () => {
        const valeurs = saisi();
        vierge = valeurs.prenom === '' && valeurs.ville === '';
        rafraichir();
        annoncer();
      });
      // On ne fait pas défiler les questions sous les doigts du visiteur.
      champ.addEventListener('focus', () => {
        enSaisie = true;
        arreter();
      });
      champ.addEventListener('blur', () => {
        enSaisie = false;
        relancer();
      });
    });

    puces.forEach((puce, rang) => {
      puce.addEventListener('click', () => {
        pilote = true;
        arreter();
        aller(rang);
        // La feuille a changé sur commande : on la relit, le fondu passé.
        // Le défilement automatique, lui, ne dit jamais rien.
        annoncer(600);
      });
    });

    if ('IntersectionObserver' in window) {
      const veille = new IntersectionObserver(
        (entrees) => {
          for (const entree of entrees) {
            visible = entree.isIntersecting;
            if (visible) {
              relancer();
            } else {
              arreter();
            }
          }
        },
        { threshold: 0.2 }
      );
      veille.observe(racine);
    }

    if (typeof moinsDeMouvement.addEventListener === 'function') {
      moinsDeMouvement.addEventListener('change', relancer);
    }

    // Le navigateur restaure parfois une saisie après un retour en arrière.
    const depart = saisi();
    vierge = depart.prenom === '' && depart.ville === '';

    majPuces();
    rafraichir();
    relancer();
  }

  function activer(portee) {
    const racine = portee && portee.querySelectorAll ? portee : document;
    racine.querySelectorAll('[data-mlo-remplir]').forEach(initialiser);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => activer(), { once: true });
  } else {
    activer();
  }

  // L’éditeur de thème recharge les sections : on réarme celle qui arrive.
  document.addEventListener('shopify:section:load', (evenement) => {
    activer(evenement.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
